import script from "./LinkUs.vue?vue&type=script&setup=true&name=LinkUs&lang=js"
export * from "./LinkUs.vue?vue&type=script&setup=true&name=LinkUs&lang=js"

import "./LinkUs.vue?vue&type=style&index=0&id=3080fdce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3080fdce"]])

export default __exports__